import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { of, Subject } from 'rxjs';
import {webSocket, WebSocketSubject} from 'rxjs/webSocket';
import { environment } from '../../environments/environment'; 
import { Plugins } from '@capacitor/core';
import { catchError } from 'rxjs/operators';
import { FoodscriptionCommonService } from './foodscription-common.service';
import { Router } from '@angular/router';

const { Storage } = Plugins;

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(private http:HttpClient,
            private authService:AuthService) {
                this.weekAray = this.generateThreeWeekArray();
             }

  totalCalories:number;
  totalCarbs:number;
  totalFat:number;
  totalProtein:number;
  weekAray:any;
  currentMeals:any = null;
  infiniteMealList = new Subject<any[]>();
  infiniteMealsListArray = this.infiniteMealList.asObservable();
  infiniteMeals:any[] = [];
  groceryIngredients:any[] = [];
  myWebSocket: WebSocketSubject<any>;
  inConversationPage:boolean = false;
  inChatPage:boolean = false;

connectToChatServer(email:string){
  if(this.myWebSocket !== undefined && this.myWebSocket.isStopped ){
    this.startWebSocket(email);
  }else if(this.myWebSocket === undefined){
    this.startWebSocket(email);
  }
}

startWebSocket(email:string){
  this.myWebSocket = webSocket('wss://i8qhtkpjy5.execute-api.us-west-2.amazonaws.com/Prod');
    this.myWebSocket.pipe(catchError(val => of(`I caught: ${val}`))).subscribe(dataFromServer => {
      if(dataFromServer.Type === "USER_MESSAGE_RECIEVED"){
        if(!this.inChatPage && !this.inConversationPage){
          console.log("not in chat or convo")
          this.myWebSocket.next( {"action":"sendmessage","data":{ "type": "USER_MESSAGES", "read": false , "message":dataFromServer.response.message, "sendTo": this.authService.username, "onlyPush": true }});
        }
      }
    });
    this.myWebSocket.next({"action":"sendmessage","data":{ "type": "NEW_CONNECTION", "read": false, "email": email}});
}

stopWebSocket(){
  this.myWebSocket.unsubscribe();
}

getMeals(fromDate:string,toDate:string,limit:string){
  let userToken = this.authService.accessToken;
  return new Promise<any>((resolve,reject)=>{
    this.http.get<any>(environment.mealDayApi+"?fromDate="+fromDate+"&toDate="+toDate+"&ordering=recipe&limit="+limit+"&offset=0",this.authService.getHeadersObject()).subscribe( meals =>{
        resolve(meals);
      },err=>{
        this.authService.checkErrorForAuth(err);
        reject();
      });
  });
}

getFavorites(){
  return new Promise<any>((resolve,reject)=>{
        this.http.get<any>(environment.userFavorites,this.authService.getHeadersObject()).subscribe( favorites => {
            resolve(favorites);
          },err=>{
            this.authService.checkErrorForAuth(err);
            reject();
          });
  });
}

getNextInfiniteMeals(nextUrl:string){
    let httpUrlArray = nextUrl.split("http");
    return new Promise<any>((resolve,reject)=>{
          this.http.get<any>("https"+httpUrlArray[1],this.authService.getHeadersObject()).subscribe( meals => {
              resolve(meals);
          },err=>{
            this.authService.checkErrorForAuth(err);
            reject();
          });
    });
}

getIngredientCategories(ingredientIds:any){
  if(this.authService.appPlatform === "web"){
    let token = this.authService.getCookie("csrftoken");
    return new Promise<any>((resolve,reject)=>{
      this.http.post<any>(environment.ingredientsCategory,ingredientIds,{
        headers :  new HttpHeaders().set('Content-Type', 'application/json').set('X-CSRFToken',token),
        withCredentials:true
      }).subscribe( ingredients => {
          resolve(ingredients);
      },err=>{
        this.authService.checkErrorForAuth(err);
        reject();
      });
    });   
  }else{
    return new Promise<any>((resolve,reject)=>{
      this.http.post<any>(environment.ingredientsCategory,ingredientIds,this.authService.getHeadersObject()).subscribe( ingredients => {
          resolve(ingredients);
      },err=>{
        this.authService.checkErrorForAuth(err);
        reject();
      });
    });
  }
  
}

saveMealsNotFollowed(mealElementId:number,followed:boolean,followedReason1:string,followedReason2:string){
  let followedReason = [];
  if(followedReason2 === undefined){
    followedReason.push(followedReason1);
  }else{
    followedReason.push(followedReason1);
    followedReason.push(followedReason2);
  }
  if(this.authService.appPlatform === "web"){
    let token = this.authService.getCookie("csrftoken");
    return new Promise<any>((resolve,reject)=>{
      this.http.put<any>(environment.mealElementApi+mealElementId+"/followed/",{
        "followed":followed,
        "followedReason":followedReason
      },{
        headers :  new HttpHeaders().set('Content-Type', 'application/json').set('X-CSRFToken',token),
        withCredentials:true
      }).subscribe( mealsFollowed => {
        resolve(mealsFollowed);
      },err =>{
        this.authService.checkErrorForAuth(err);
        reject();
      });
    });
  }else{
    return new Promise<any>((resolve,reject)=>{
      this.http.put<any>(environment.mealElementApi+mealElementId+"/followed/",{
        "followed":followed,
        "followedReason":followedReason
      },this.authService.getHeadersObject()).subscribe( mealsFollowed => {
        resolve(mealsFollowed);
      },err =>{
        this.authService.checkErrorForAuth(err);
        reject();
      });
    });
  }

  
}

searchMedialConditions(searchText:string){
  return this.http.get<any>(environment.searchDisease+"?condition="+searchText,this.authService.getHeadersObject())
}

saveUserInfo(userInfo:any):Promise<any>{
 // let userPreferenceId:any = this.authService.userPreferenceId;
 let userPreferenceId:any = undefined;
  return new Promise((resolve,reject) => {
    if(userPreferenceId === undefined){
      Storage.get({key:'fsUserPreferenceId'}).then( storage => {
        userPreferenceId = JSON.parse(storage.value).preferencesId;
        if(this.authService.appPlatform === "web"){
          let token = this.authService.getCookie("csrftoken");
          this.http.patch<any>(environment.saveUserInfo+userPreferenceId+"/",userInfo,{
            headers :  new HttpHeaders().set('Content-Type', 'application/json').set('X-CSRFToken',token),
            withCredentials:true
          }).subscribe( () => {
            resolve();
          },err => {
            this.authService.checkErrorForAuth(err);
          });
        }else{
          this.http.patch<any>(environment.saveUserInfo+userPreferenceId+"/",userInfo,this.authService.getHeadersObject()).subscribe( () => {
            resolve();
          },err =>{
            this.authService.checkErrorForAuth(err);
          });
        }
      })
    }else{
      if(this.authService.appPlatform === "web"){
        let token = this.authService.getCookie("csrftoken");
        this.http.patch<any>(environment.saveUserInfo+userPreferenceId+"/",userInfo,{
          headers :  new HttpHeaders().set('Content-Type', 'application/json').set('X-CSRFToken',token),
          withCredentials:true
        }).subscribe( () => {
          resolve();
        },err=>{
          this.authService.checkErrorForAuth(err);
        });
      }else{
        this.http.patch<any>(environment.saveUserInfo+userPreferenceId+"/",userInfo,this.authService.getHeadersObject()).subscribe( () => {
          resolve();
        },err => {
          this.authService.checkErrorForAuth(err);
        });
      }
    }
  });
}

getUserWeights(){
  return this.http.get<any>(environment.meApi+this.authService.userPreferenceId+"/data/weight/",this.authService.getHeadersObject());
}

getUserHeights(){
  return this.http.get<any>(environment.meApi+this.authService.userPreferenceId+"/data/height/",this.authService.getHeadersObject());
}

currentDate(){
  return new Date().getDate();
}

startDate(){
  return this.currentDate() - (new Date().getDay() - 1);
}

getFromDate(currentDateIndex:number){
  if(currentDateIndex < 7){
      return this.weekAray[0].toLocaleDateString(); 
  }else if(currentDateIndex >6 && currentDateIndex <14){
      return this.weekAray[7].toLocaleDateString();
  }else{
      return this.weekAray[14].toLocaleDateString();
  }
}

getToDate(currentDateIndex:number){
  if(currentDateIndex < 7){
      return this.weekAray[6].toLocaleDateString(); 
  }else if(currentDateIndex >6 && currentDateIndex <14){
      return this.weekAray[13].toLocaleDateString();
  }else{
      return this.weekAray[20].toLocaleDateString();
  }
}

storeNewMealsInStore(meals:any){
    if(this.currentMeals.length === 0){
        this.currentMeals = meals; 
    }
}

generateThreeWeekArray():Date[]{
  const weekAray = [];
  let currentDay = new Date();
  weekAray.push(new Date(currentDay.toISOString().substring(0,10)))
  for(let i=0; i<5; i++){
    currentDay.setDate(currentDay.getDate() -1 );
    weekAray.push(new Date(currentDay.toISOString().substring(0,10)))
  }
  weekAray.reverse();
  currentDay = new Date();
  for(let i=0; i<21; i++){
    if(i >= 6){
      currentDay.setDate(currentDay.getDate() + 1);
      weekAray.push(new Date(currentDay.toISOString().substring(0,10)));
    }
  }
  return weekAray;
}

  generateCurrentWeekArray():Date[]{
    const weekAray = [];
    let currentDay = new Date();
    weekAray.push(new Date(currentDay.toISOString().substring(0,10)))
    for(let i=0; i<6; i++){
      currentDay.setDate(currentDay.getDate() - 1);
      weekAray.push(new Date(currentDay.toISOString().substring(0,10)))
    }
    weekAray.reverse();
    return weekAray;
  }

  generateGroceryListArray(mealResults:any){
    const groceryIngredientsList = this.groceryIngredients;
    for(let i=0; i<mealResults.length; i++){
      let newObj = {
        'date':null,
        'title':null,
        'cart':false,
        'ingredients':[]
      };
      this._generateMealsIngredients(newObj,mealResults,groceryIngredientsList,i);
    }
   this.groceryIngredients = groceryIngredientsList;
  }

  private _generateMealsIngredients(newObj:any,mealResults:any,groceryIngredientsList:any,i:number){
    for(let j=0; j<mealResults[i].meals.length; j++){
      for(let k=0; k<mealResults[i].meals[j].mealElements.length; k++){
        newObj.date = mealResults[i].date;
        newObj.title = mealResults[i].meals[j].mealElements[k].recipe.title;
        this._generateIndividualIngredients(newObj,mealResults,i,j,k);
        groceryIngredientsList.push(newObj);
        newObj = {
          'date':null,
          'title':null,
          'cart':false,
          'ingredients':[]
        };
      }
    }
  }

  private _generateIndividualIngredients(newObj:any,mealResults:any,i:number,j:number,k:number){
    for(let l=0; l<mealResults[i].meals[j].mealElements[k].recipe.extendedIngredients.length; l++){
      newObj.ingredients.push({
        'value':(mealResults[i].meals[j].mealElements[k].recipe.extendedIngredients[l].amount * mealResults[i].meals[j].mealElements[k].recipe.servings),
        'unit':mealResults[i].meals[j].mealElements[k].recipe.extendedIngredients[l].unit,
        'name':mealResults[i].meals[j].mealElements[k].recipe.extendedIngredients[l].ingredient,
        'ingredientId':mealResults[i].meals[j].mealElements[k].recipe.extendedIngredients[l].ingredientId,
        'id':mealResults[i].meals[j].mealElements[k].recipe.extendedIngredients[l].id,
        'checked':true
      })
    }
  }
  
}
